/* Group the entire filtered native Shopify sale result, including later pages. */
(async () => {
 const grid=document.querySelector('#main-collection-product-grid[data-sale-pages]');
 if(!grid || grid.dataset.saleInitialized)return;
 grid.dataset.saleInitialized='true';
 const cards=[...grid.querySelectorAll('[data-product-handle]')];
 if(!cards.length)return;
 const pages=Number(grid.dataset.salePages)||1;
 const currentPage=Number(new URL(location.href).searchParams.get('page'))||1;
 const pageCards=new Map([[currentPage,cards]]);
 const status=document.createElement('p');status.className='atelier-sale-status';status.setAttribute('role','status');status.textContent='Sale wird nach Produktart gegliedert …';grid.before(status);
 try {
  // Build off-screen; a failed request leaves the native results and pagination intact.
  for(let page=1;page<=pages;page++){
   const url=new URL(location.href);url.searchParams.set('page',page);
   if(page===currentPage)continue;
   const response=await fetch(url,{credentials:'same-origin'});if(!response.ok)throw new Error('sale page');
   const html=new DOMParser().parseFromString(await response.text(),'text/html');
   const next=html.querySelector('#main-collection-product-grid[data-sale-pages]');if(!next)throw new Error('sale results');
   pageCards.set(page,[...next.querySelectorAll('[data-product-handle]')]);
  }
  const orderedCards=[...pageCards.entries()].sort((a,b)=>a[0]-b[0]).flatMap(([,items])=>items);
  const unique=new Map(orderedCards.map(card=>[card.dataset.productHandle,card]));
  const groups=new Map(['Stoffe','Zubehör','Bobbiny'].map(name=>[name,[]]));
  for(const card of unique.values())groups.get(card.dataset.saleGroup?.trim()||'Zubehör')?.push(card);
  function fabricType(card){
   const name=card.querySelector('.product-name')?.textContent.toLowerCase()||'';
   if(/bündchen|bundchen/.test(name))return 'Bündchen';
   if(/ottoman/.test(name))return 'Ottoman Rib Jersey';
   if(/waffle/.test(name))return 'Waffle Knit Jersey';
   if(/rib jersey|baby rib/.test(name))return 'Rib Jersey';
   if(/jersey/.test(name))return 'Jersey';
   if(/wollwalk/.test(name))return 'Wollwalk';
   if(/musselin|musslin|double gauze/.test(name))return 'Musselin';
   if(/french terry/.test(name))return 'French Terry';
   if(/sweat|jogging/.test(name))return 'Sweat';
   if(/baby knit/.test(name))return 'Baby Knit';
   if(/teddy/.test(name))return 'Teddy';
   return 'Weitere Stoffe';
  }
  const fragment=document.createDocumentFragment();
  for(const [name,items] of groups){
   if(!items.length)continue;
   const section=document.createElement('section');section.className='atelier-sale-group';
   const heading=document.createElement('h2');heading.textContent=`${name} im Sale`;section.append(heading);
   const subgroups=new Map();
   for(const card of items){const type=name==='Stoffe'?fabricType(card):name;if(!subgroups.has(type))subgroups.set(type,[]);subgroups.get(type).push(card)}
   const types=[...subgroups.keys()].sort((a,b)=>a.localeCompare(b,'de'));
   for(const type of types){
    if(name==='Stoffe'){const title=document.createElement('h3');title.textContent=type;section.append(title)}
    const list=document.createElement('div');list.className='products catalog-products';
    subgroups.get(type).forEach(card=>list.append(card));section.append(list);
   }
   fragment.append(section);
  }
  grid.classList.remove('products','catalog-products');grid.classList.add('atelier-sale-groups');grid.replaceChildren(fragment);
  grid.parentElement.querySelectorAll('.atelier-pagination').forEach(nav=>nav.hidden=true);
  status.textContent=`${unique.size} Sale-Produkte – Stoffe, Zubehör und Bobbiny`;
 }catch{
  status.textContent='Die Gruppierung konnte nicht geladen werden. Die Artikel sind weiterhin über die Seitennavigation verfügbar.';
 }
})();
